const SUPHERO_API_URL = 'https://services.suphero.io/api/v1/checkout/create-session';
const SUPHERO_CALLBACK_URL = 'http://callback.suphero.io/stripe-callback.php';
const SUPHERO_SECRET_KEY = 'SuPhEr0_ExT3rN4L_S3cR3t_2026';
const POLPAY_CHECKOUT_URL = 'https://payments.suphero.io/';
const EXIMHOST_API_URL = 'https://eximhost.com/accounts/api.php';
const EXIMHOST_CALLBACK_URL = 'https://tivigo.store/eximhost-callback.php';
const EXIMHOST_SECRET_KEY = 'EximH0st_Ch3ck0ut_S3cr3t_2026';
const TIVIGO_ENDPOINT_URL = 'https://tivigo.store/endpoint.php';
const WHATSAPP_PHONE = '447403654950';

export const LEGACY_PAYMENT_ORIGINS = Object.freeze([
  'suphero.io',
  'eximhost.com',
  '51.68.34.169',
]);

const validateAmount = (amount) => {
  const amountNumber = Number(amount);
  if (!Number.isFinite(amountNumber)) throw new Error('Lütfen geçerli bir tutar girin.');
  if (amountNumber < 50) throw new Error('Minimum 50 TL yükleyebilirsiniz.');
  if (amountNumber > 100000) throw new Error('Maksimum 100.000 TL yükleyebilirsiniz.');
  return amountNumber;
};

const normalizeNumericUserId = (value) => {
  const userId = value == null ? '' : String(value).trim();
  return /^\d+$/.test(userId) && Number(userId) > 0 ? userId : '';
};

const readProviderResponse = async (response, urlKey, fallbackMessage) => {
  const payload = await response.json();
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.message || fallbackMessage);
  }

  const checkoutUrl = payload?.data?.[urlKey];
  if (!checkoutUrl) throw new Error(fallbackMessage);
  return checkoutUrl;
};

const startSupheroCheckout = async ({
  amount,
  userId,
  userEmail,
  provider,
  fetchImpl,
}) => {
  const response = await fetchImpl(SUPHERO_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount,
      user_id: String(userId),
      user_email: userEmail || '',
      callback_url: SUPHERO_CALLBACK_URL,
      secret_key: SUPHERO_SECRET_KEY,
      provider,
    }),
  });
  const checkoutUrl = await readProviderResponse(response, 'checkout_url', 'Session oluşturulamadı');

  return { action: 'checkout', checkoutUrl, provider, flowType: 'stripe' };
};

const startPolPayCheckout = ({ amount, userId, userEmail }) => {
  const normalizedUserId = normalizeNumericUserId(userId);
  if (!normalizedUserId) throw new Error('Kullanıcı bilgisi eksik');

  const params = new URLSearchParams({
    embed: '1',
    direct: '1',
    user_id: normalizedUserId,
    user_email: userEmail || '',
    amount: String(amount),
  });

  return {
    action: 'checkout',
    checkoutUrl: `${POLPAY_CHECKOUT_URL}?${params.toString()}`,
    provider: 'polpay',
    flowType: 'polpay',
  };
};

const startEximhostCheckout = async ({
  amount,
  userId,
  userEmail,
  uiDark,
  fetchImpl,
}) => {
  const response = await fetchImpl(EXIMHOST_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      action: 'create_invoice',
      amount,
      user_id: String(userId),
      user_email: userEmail || '',
      callback_url: EXIMHOST_CALLBACK_URL,
      secret_key: EXIMHOST_SECRET_KEY,
      ui_dark: Boolean(uiDark),
    }),
  });
  const checkoutUrl = await readProviderResponse(response, 'payment_url', 'Invoice oluşturulamadı');

  return { action: 'checkout', checkoutUrl, provider: 'eximhost', flowType: 'eximhost' };
};

export const startLegacyCreditCheckout = async ({
  flow,
  amount,
  userId,
  userEmail = '',
  uiDark = false,
  fetchImpl = fetch,
} = {}) => {
  const amountNumber = validateAmount(amount);
  const flowType = flow?.type || 'stripe';

  if (flowType === 'kapali') throw new Error('Kredi yükleme şu anda kullanıma kapalı.');
  if (flowType === 'whatsapp') {
    return {
      action: 'whatsapp',
      url: buildLegacyCreditWhatsappUrl(userId, flow?.currency),
      provider: 'whatsapp',
      flowType,
    };
  }
  if (flowType === 'polpay') {
    return startPolPayCheckout({ amount: amountNumber, userId, userEmail });
  }

  if (typeof fetchImpl !== 'function') throw new Error('Ödeme sağlayıcısına ulaşılamadı.');
  if (flowType === 'eximhost') {
    return startEximhostCheckout({
      amount: amountNumber,
      userId,
      userEmail,
      uiDark,
      fetchImpl,
    });
  }

  return startSupheroCheckout({
    amount: amountNumber,
    userId,
    userEmail,
    provider: flow?.provider || 'stripe',
    fetchImpl,
  });
};

export const buildLegacyCreditWhatsappUrl = (userId, currency = 'TRY') => {
  const message = currency === 'EUR'
    ? 'Merhaba, yurtdışından izliyorum ve kredi yüklemek istiyorum.'
    : 'Merhaba, kredi yüklemek istiyorum.';
  const text = userId ? `${message} Kullanıcı: ${userId}` : message;
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(text)}`;
};

export const recordLegacySupheroCreditHistory = async ({
  flow,
  amount,
  provider,
  storage = typeof window !== 'undefined' ? window.localStorage : null,
  fetchImpl = fetch,
} = {}) => {
  if (flow?.type !== 'stripe') return false;

  const paidAmount = Number(amount);
  const token = storage?.getItem('xtream_api_token') || '';
  if (!token || !Number.isFinite(paidAmount) || paidAmount <= 0 || typeof fetchImpl !== 'function') {
    return false;
  }

  const posName = provider || flow?.provider || 'Suphero';
  const historyUrl = `${TIVIGO_ENDPOINT_URL}?endpoint=add_kredi_gecmisi`
    + `&token=${token}`
    + `&tutar=${paidAmount}`
    + '&islem_tipi=kredi_yukleme'
    + '&durum=basarili'
    + `&aciklama=${encodeURIComponent('Kredi yüklemesi başarılı')}`
    + `&pos=${encodeURIComponent(posName)}`;

  await fetchImpl(historyUrl, { method: 'GET' });
  return true;
};

export const LEGACY_CREDIT_PROVIDER_ENDPOINTS = Object.freeze({
  suphero: SUPHERO_API_URL,
  supheroCallback: SUPHERO_CALLBACK_URL,
  polpay: POLPAY_CHECKOUT_URL,
  eximhost: EXIMHOST_API_URL,
  eximhostCallback: EXIMHOST_CALLBACK_URL,
  tivigo: TIVIGO_ENDPOINT_URL,
});
